export const gravityMessage = {
  success: {
    background: "rgba(55, 176, 109, 0.5)",
    border: "2px solid #37b06d",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    color: "#003b58",
  },
  info: {
    background: "rgba(66, 153, 225, 0.5)",
    border: "2px solid #4299e1",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    color: "#002c47",
  },
  warning: {
    background: "rgba(255, 159, 67, 0.5)",
    border: "2px solid #ff9f43",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    color: "#663c00",
  },
  error: {
    background: "rgba(234, 67, 53, 0.5)",
    border: "2px solid #ea4335",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    color: "#5c0000",
  },
};

export const gravityLabels = {
  success: "Succès",
  info: "Information",
  warning: "Avertissement",
  error: "Erreur",
};
